import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Erstgespräch",
    text: "Wir hören zu: Wo geht bei Ihnen Zeit verloren, wo entgehen Ihnen Aufträge? Kostenlos und unverbindlich — telefonisch oder vor Ort.",
  },
  {
    n: "02",
    title: "Unverbindliches Angebot",
    text: "Sie bekommen einen klaren Vorschlag mit fester Preisangabe. Kein Kleingedrucktes, keine versteckten Kosten.",
  },
  {
    n: "03",
    title: "Umsetzung",
    text: "Wir richten alles ein und testen es gemeinsam mit Ihnen. Sie müssen nichts installieren und nichts Kompliziertes lernen.",
  },
  {
    n: "04",
    title: "Laufender Support",
    text: "Wir bleiben ansprechbar. Wenn sich etwas ändert oder Sie Fragen haben, sind wir persönlich für Sie da.",
  },
];

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 70%", "end 60%"],
  });
  const lineScale = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section
      id="ablauf"
      data-testid="process-section"
      className="bg-white py-24 sm:py-32 scroll-mt-24"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-[#9A8420]" />
            <span className="eyebrow text-[#9A8420]">So läuft es ab</span>
          </div>
          <h2 className="mt-6 font-bold text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-[#16273F]">
            In vier Schritten zur Entlastung
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
            Vom ersten Gespräch bis zum laufenden Betrieb begleiten wir Sie
            persönlich. Sie behalten immer die Kontrolle.
          </p>
        </motion.div>

        <div ref={ref} className="mt-16 relative pl-14 sm:pl-20">
          {/* track + animated gold fill */}
          <div className="absolute left-[26px] sm:left-[38px] top-2 bottom-2 w-px bg-slate-200" />
          <motion.div
            style={{ scaleY: lineScale }}
            className="absolute left-[26px] sm:left-[38px] top-2 bottom-2 w-px origin-top bg-[#9A8420]"
          />

          <div className="space-y-12 sm:space-y-16">
            {steps.map((s, i) => (
              <motion.div
                key={s.n}
                data-testid={`process-step-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="relative"
              >
                <div className="absolute -left-14 sm:-left-20 top-0 flex items-center justify-center w-[52px] sm:w-[76px]">
                  <span className="font-extrabold text-3xl sm:text-4xl text-[#16273F] bg-white px-1 tabular-nums">
                    {s.n}
                  </span>
                </div>
                <h3 className="font-bold text-2xl sm:text-3xl text-[#16273F]">
                  {s.title}
                </h3>
                <p className="mt-3 text-slate-600 leading-relaxed max-w-xl">{s.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
